module.exports = __webpack_public_path__ + "static/media/draggable.5103535f.svg";